<template>
  <ul class="tab-list tiles d-flex align-items-center">
    <li v-for="(level,index) in labels" :key="index" :data-item-index="index">{{level}}</li>
  </ul>
</template>
<script>
export default {
  props: {
    companyLabels: {
      type: String
    }
  },
  computed: {
    labels() {
    	if(this.companyLabels){
    		if(this.companyLabels.indexOf(",")>-1){
					return this.companyLabels.split(",")
				}else{
					return [this.companyLabels]
				}
    	}
    }
  },
  mounted () {
		
  }
};
</script>
<style lang="scss" scoped>
.tab-list {
  font-size: 0.3rem;
  margin: 0;
  padding: 0.2rem 0;
  > li {
    background-color: #65d4a0;
    border-radius: 0.06rem;
    font-size: 0.31rem;
    color: #fff;
    text-align: center;
    /*&:not(:first-child) {*/
      margin-right: 0.2rem;
      margin-bottom: 0.2rem;
    /*}*/
    white-space: nowrap;
    padding: 0.06rem 0.3rem;
    $levels: (
      #007bff,
      // #6610f2,
        // #6f42c1,
        // #e83e8c,
        #dc3545,
      #fd7e14,
      #ffc107,
      #28a745,
      #20c997,
      #17a2b8,
      #fff,
      #6c757d,
      #343a40,
      #007bff,
      #6c757d,
      #28a745,
      #17a2b8,
      #ffc107,
      #dc3545,
      #f8f9fa,
      #343a40
    );
    @for $index from 1 through length($levels) {
      &[data-item-index="#{$index}"] {
        background-color: nth($levels, $index);
      }
    }
  }
}
</style>